import DownloadElements from "./ManualDownloadElements";

const Embed = ({selectedChart, mode, publicationType}) => {


    return (<>
        {selectedChart.title &&<h3 className='highcharts-title' dangerouslySetInnerHTML={ {__html: selectedChart.title}}></h3>}
        <DownloadElements chart={selectedChart} mode={mode} PType={publicationType} />
        {selectedChart.subtitle && <h6 className='highcharts-subtitle' dangerouslySetInnerHTML={ {__html: selectedChart.subtitle}}></h6>}
   <iframe key={selectedChart.file} title={selectedChart.title} src={`${window.PUBLICATION_DATA_URL}${selectedChart.file}#${mode}`} loading="lazy" ></iframe>
    </>)
}

export default Embed;
